"use es6";

import { createContext } from 'react';
const LayoutGroupContext = /*#__PURE__*/createContext({});
export { LayoutGroupContext };